// util to centrally control onboarding/tutoriels display
// Temporary hard kill-switch: set to true to disable ALL onboarding immediately.
// Set to false to restore behavior (or use VITE_DISABLE_ALL_ONBOARDING / localStorage override).
const FORCE_DISABLE_ALL_ONBOARDING = true;

export function isOnboardingDisabled(): boolean {
  if (FORCE_DISABLE_ALL_ONBOARDING) return true;
  try {
    const env = (import.meta.env as any).VITE_DISABLE_ALL_ONBOARDING === 'true';
    if (typeof window === 'undefined') return env;
    const local = localStorage.getItem('force-disable-onboarding') === 'true';
    return env || local;
  } catch (e) {
    return false;
  }
}

export function isOnboardingEnabled(): boolean {
  return !isOnboardingDisabled();
}
